import { AppEnvVariables } from "./environment.constants";

export const PAGE_URL = {
  HOME: "/pay-analytics/home",
  CLIENT_SEARCH: "/pay-analytics/client-selection",
  MY_REPORTS: "/pay-analytics/my-reports",
  JOB_PRICING: "/sjpr",
  JOB_PRICING_LIST: "/sjpr/job-search-results",
  JOB_PRICING_DETAILS: "/sjpr/job-pricing-details",
  REWARD_BENCHMARKING: "/pay-analytics/reward-benchmark",
  REWARD_BENCHMARKING_HOME: "/pay-analytics/reward-benchmark",
  FEEDBACK: "https://kornferry.surveymonkey.com/r/ZQBVLGX",
  CREATE_PEER_GROUP: `${AppEnvVariables.PAY_PGCG_URL}/create`,
  CREATE_CUSTOM_GRADE: `${AppEnvVariables.PAY_PGCG_URL}/custom-grades/create`
};
